import { createAction } from '@reduxjs/toolkit';

export const requestCreatePoll = createAction('request/createPoll');
export const requestUpdatePoll = createAction('request/updatePoll');
export const requestViewPollResults = createAction('request/viewPollResults');
